import PassportRecordRequirements from "./PassportRecordRequirements";

export default PassportRecordRequirements;